// Modal dialog (base) classes

const modalBase = [
  'w-full',
  'transform',
  'overflow-hidden',
  'rounded',
  'bg-white',
  'transition-all',
];

// Modal dialog (base) sizes
const modalSizes = {
  xs: 'max-w-xs',
  sm: 'max-w-[450px]',
  md: 'max-w-[640px]',
  lg: 'max-w-[750px]',
  xl: 'max-w-[900px]',
  '2xl': 'max-w-[1100px]',
  '3xl': 'max-w-[1300px]',
  full: 'min-h-dvh',
  'w-90': 'w-[90dvw] h-[90dvh] max-w-[1700px]',
};

// Modal backdrop styles
const backdrop = 'fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm';

// Modal header styles
const header =
  'flex justify-between items-center border-b py-3 px-6 font-medium';

// Modal body styles
const body = 'p-6';

const footer = '';

export const ModalStyles = {
  modalSizes,
  modalBase,
  backdrop,
  header,
  body,
  footer,
};
